import { DirectoryEntitySearchDto } from "@/ContactDirectory/Api/ClientParameters/DirectoryEntityDto";
import {
    DirectoryEntityType,
    DirectoryHealthCareProviderSearchDto,
    DirectoryOtherEstablishmentSearchDto,
    DirectoryPharmacySearchDto
} from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models//DirectoryHealthCareProvider";
import { DirectoryOtherEstablishment } from "@/ContactDirectory/Models//DirectoryOtherEstablishment";
import { DirectoryPharmacy } from "@/ContactDirectory/Models//DirectoryPharmacy";
import { IDirectoryEntity } from "../Models/IDirectoryEntity";

export const useDirectoryEntityConstructor = (type: DirectoryEntityType): (entity: DirectoryEntitySearchDto) => IDirectoryEntity => {
    switch (type) {
        case DirectoryEntityType.HealthcareProvider:
            return (entity: DirectoryHealthCareProviderSearchDto) => DirectoryHealthCareProvider.fromSearchDto(entity);
        case DirectoryEntityType.Pharmacy:
            return (entity: DirectoryPharmacySearchDto) => DirectoryPharmacy.fromSearchDto(entity);
        case DirectoryEntityType.Other:
            return (entity: DirectoryOtherEstablishmentSearchDto) => DirectoryOtherEstablishment.fromSearchDto(entity);
    }
};
